module.exports = __webpack_public_path__ + "img/wh2_main_great_vortex_map.8c61d021.png";